import { SetupContext } from "@vue/composition-api";

export default function getRouteIntParam(context: SetupContext, paramName: string) {
  return parseInt(context.root.$route.params[paramName], 10);
}
